import { render, staticRenderFns } from "./education-recruit.vue?vue&type=template&id=140074bc&scoped=true&"
import script from "./education-recruit.vue?vue&type=script&lang=js&"
export * from "./education-recruit.vue?vue&type=script&lang=js&"
import style0 from "./education-recruit.vue?vue&type=style&index=0&id=140074bc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "140074bc",
  null
  
)

export default component.exports